import {FC, MouseEvent, MouseEventHandler} from 'react'
import {isServiceActive} from "../../lib/booking";

interface Props {
    booking?: Booking,
    handleAddRemove: Function,
    service: any,
}

const ServiceButton: FC<Props> = ({service, booking, handleAddRemove}) => {

    const closeTooltip = (event: MouseEvent) => {
        event.currentTarget.parentElement.classList.add("wco-info-tooltip--hidden")
        event.preventDefault()
        event.stopPropagation()
    }

    const openTooltip = (event: MouseEvent) => {
        console.log('open')
        const collection = document.getElementsByClassName("wco-info-tooltip--hidden");
        for (let i = 0; i < collection.length; i++) {
            collection[i].classList.remove("wco-info-tooltip--hidden");
        }
        event.preventDefault()
        event.stopPropagation()
    }

    if (booking.car.autoload) {
        for (let i = 0; i < booking.populated_services.length; i++) {
            if(booking.populated_services[i] === service.slug) {
                handleAddRemove(service)
                booking.car.autoload = false;
            }
        }
    }


    return (
        <div id={'btn-' + service.slug} className={`btn-service ${isServiceActive(service.slug, booking) ? "active" : ""} `}>
            <div className={"btn-service__image"}><img width={"30px"} src={service.image}/></div>
            <div className={"btn-service__header"}>
                <h4>{service.name}</h4>
                <div className="wco-info" onMouseDown={(event) => openTooltip(event)}>
                    <i className="far fa-info-circle" aria-hidden="true"/>
                    <div className="wco-info-tooltip">
                        <div className="wco-info-tooltip__close" onMouseDown={(event) => closeTooltip(event)}>
                            <i className="popup_close far fa-times-circle" aria-hidden="true"></i>
                        </div>
                        <div dangerouslySetInnerHTML={{__html: service.info}}/>
                    </div>
                </div>
            </div>
            <div className={"btn btn--skyblue btn-service__action"} id={'click-' + service.slug}
                 onClick={(event) => handleAddRemove(service, event)}>
                {isServiceActive(service.slug, booking) ? "Vald" : "Välj"}
            </div>
        </div>
    )
};

export default ServiceButton
